var React = require('react');

function TimeSecondary (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM9 6.75H5.25V3H6.75V5.25H9V6.75Z"}));
}

TimeSecondary.defaultProps = {"width":"12","height":"12","viewBox":"0 0 13 12","fill":"#FFC800"};

module.exports = TimeSecondary;

TimeSecondary.default = TimeSecondary;
